import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import clubService from "../services/clubService";

const rejectMessage = (err) =>
  typeof err === "string"
    ? err
    : err?.message || err?.toString?.() || "Request failed";

const normalizeList = (res) => {
  const raw = res?.data ?? res;
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.clubs)) return raw.clubs;
  if (Array.isArray(raw?.items)) return raw.items;
  if (Array.isArray(raw?.docs)) return raw.docs;
  if (Array.isArray(raw?.data)) return raw.data;
  if (Array.isArray(raw?.data?.clubs)) return raw.data.clubs;
  if (Array.isArray(raw?.data?.items)) return raw.data.items;
  if (Array.isArray(raw?.data?.docs)) return raw.data.docs;
  return [];
};

export const clubListResponce = createAsyncThunk(
  "club/list",
  async (params = {}) => {
    const res = await clubService.listClubs(params);
    return normalizeList(res);
  }
);

export const createClubResponce = createAsyncThunk(
  "club/create",
  async (body, { rejectWithValue }) => {
    try {
      return await clubService.createClub(body);
    } catch (err) {
      return rejectWithValue(rejectMessage(err));
    }
  }
);

export const updateClubResponce = createAsyncThunk(
  "club/update",
  async ({ id, body }, { rejectWithValue }) => {
    try {
      return await clubService.updateClub(id, body);
    } catch (err) {
      return rejectWithValue(rejectMessage(err));
    }
  }
);

export const getClubAdminResponce = createAsyncThunk(
  "club/adminDetail",
  async (id) => {
    const res = await clubService.getClubAdmin(id);
    const raw = res?.data ?? res;
    return raw;
  }
);

const clubSlice = createSlice({
  name: "club",
  initialState: {
    clubList: [],
    clubDetail: null,
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(clubListResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(clubListResponce.fulfilled, (state, action) => {
        state.loading = false;
        state.clubList = action.payload;
      })
      .addCase(clubListResponce.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(createClubResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(createClubResponce.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createClubResponce.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateClubResponce.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateClubResponce.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateClubResponce.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getClubAdminResponce.fulfilled, (state, action) => {
        state.clubDetail = action.payload;
      });
  },
});

export default clubSlice.reducer;
